<template>
  <div
    class="mobilePage"
    ref="scroller"
    @click="pageClick"
    @scroll.passive="onScroll"
  >
    <div class="stickyHead" ref="header">
      <header class="topBar">
        <div class="logoWrap">
          <img class="logoImg" :src="logoImg" alt="" />
          <span>黄果短剧</span>
        </div>
        <button type="button" class="clientBtn" @click.stop="onClient($event)">
          <span class="clientIcon">
            <img :src="downloadIcon" alt="" />
          </span>
          <span>客户端</span>
        </button>
      </header>
      <nav class="navScroll" ref="navScroll">
        <div class="navRow">
          <button
            v-for="item in menus"
            :key="item.key"
            type="button"
            class="navItem"
            :class="{ 'is-active': activeKey === item.key }"
            :data-key="item.key"
            @click.stop="scrollToSection(item.key)"
          >
            <span class="navLabel">
              <span class="navGhost">{{ item.label }}</span>
              <span class="navText">{{ item.label }}</span>
            </span>
            <i class="navLine"></i>
          </button>
        </div>
      </nav>
    </div>

    <section class="hero" ref="home">
      <div class="heroVisual">
        <img class="heroPhoto" :src="heroImg" alt="" />
      </div>
      <div class="heroShade"></div>
      <div class="heroCopy">
        <img class="heroTitle" :src="titleImg" alt="黄果短剧" />
        <p class="heroSlogan">用AI重塑AV的无限可能</p>
        <div class="heroTag">AI短剧 · AI漫剧</div>
        <p class="heroDesc">
          不同主题，不同惊喜，每次打开<br />都有新的故事发生。
        </p>
      </div>
      <div class="downloadRow">
        <button type="button" class="dlBtn" @click.stop="onApple($event)">
          <img class="dlIcon" :src="downloadWhiteIcon" alt="" />
          <span class="dlText">
            <span class="dlMain">苹果下载</span>
            <span class="dlSub">iOS 版本</span>
          </span>
        </button>
        <button type="button" class="dlBtn" @click.stop="onAndroid($event)">
          <img class="dlIcon" :src="downloadWhiteIcon" alt="" />
          <span class="dlText">
            <span class="dlMain">安卓下载</span>
            <span class="dlSub">Android 版本</span>
          </span>
        </button>
        <button
          type="button"
          class="dlBtn"
          @click.stop="onAndroidSpare($event)"
        >
          <img class="dlIcon" :src="downloadWhiteIcon" alt="" />
          <span class="dlText">
            <span class="dlMain">安卓备用</span>
            <span class="dlSub">备用线路下载</span>
          </span>
        </button>
      </div>
    </section>

    <section class="highlights" ref="highlights">
      <img
        class="sectionFill"
        :src="highlightsImg"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </section>

    <section class="genres" ref="genres">
      <img
        class="sectionFill"
        :src="genresImg"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </section>

    <section class="immersive">
      <img
        class="sectionFill"
        :src="immersiveImg"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </section>

    <section class="wish" ref="wish">
      <img
        class="wishArt"
        :src="wishImg"
        alt=""
        loading="lazy"
        decoding="async"
      />
      <button type="button" class="wishBtn" @click.stop="onClient($event)">
        <span class="wishIcon">
          <img :src="editIcon" alt="" />
        </span>
        <span>去许愿</span>
      </button>
    </section>

    <section class="creator" ref="original">
      <img
        class="creatorBg"
        :src="creatorImg"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </section>

    <section class="about" ref="about">
      <div class="aboutLogo">
        <img :src="logoImg" alt="" />
        <span>黄果短剧</span>
      </div>
      <p class="aboutSlogan">打开黄果短剧，遇见更多精彩故事</p>
    </section>

    <footer class="footer">
      <div class="footerLogo">
        <img :src="logoImg" alt="" />
        <span>黄果短剧</span>
      </div>
      <p class="footerSlogan">随时随地，打开好戏世界</p>
      <div class="footerAddresses" @click.stop>
        <p>
          <span>国内地址：</span>
          <a href="https://hgdhy1.com" target="_blank" rel="noopener noreferrer"
            >https://hgdhy1.com</a
          >
        </p>
        <p>
          <span>最新地址：</span>
          <a
            href="https://d1moq9tellvyj5.cloudfront.net"
            target="_blank"
            rel="noopener noreferrer"
            >https://d1moq9tellvyj5.cloudfront.net</a
          >
        </p>
        <p>
          <span>官网地址：</span>
          <a
            href="https://huangguo.com"
            target="_blank"
            rel="noopener noreferrer"
            >https://huangguo.com</a
          >
        </p>
        <p>
          <span>永久发布页：</span>
          <a href="https://hgdj.fm" target="_blank" rel="noopener noreferrer"
            >https://hgdj.fm</a
          >
        </p>
      </div>
      <div class="footerCols">
        <div class="footerCol">
          <p class="footerTitle">服务支持</p>
          <p>常见问题</p>
          <p>用户反馈</p>
        </div>
        <div class="footerCol">
          <p class="footerTitle">关于我们</p>
          <p>公司简介</p>
          <p>联系我们</p>
        </div>
        <div class="footerCol">
          <p class="footerTitle">法律信息</p>
          <p>用户协议</p>
          <p>隐私政策</p>
        </div>
      </div>
      <p class="copyright">Copyright © 2026 黄果短剧. All Rights Reserved.</p>
    </footer>

    <InstallGuide
      :show="iosPromptShow || androidPromptShow"
      :type="iosPromptShow ? 'ios' : 'android'"
      @close="closeGuide"
      @help="openOnlineService"
    />
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">请使用Safari浏览器进行下载</div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import getCustomerServiceUrl from "@/api/getCustomerServiceUrl";
import InstallGuide from "./installGuide.vue";
import {
  getDeviceType,
  getSystemType,
  getSystemVersion,
  getTraceId,
  landingPageClick
} from "@/utils/eventTracker";
import logoImg from "@/assets/images/land/logo.webp";
import heroImg from "@/assets/images/land/hero-h5.webp";
import titleImg from "@/assets/images/land/title.webp";
import highlightsImg from "@/assets/images/land/highlights-h5.webp";
import genresImg from "@/assets/images/land/genres-h5.webp";
import immersiveImg from "@/assets/images/land/immersive-h5.webp";
import wishImg from "@/assets/images/land/wish-h5.webp";
import creatorImg from "@/assets/images/land/creator-h5.webp";
import downloadIcon from "@/assets/images/land/download.svg";
import downloadWhiteIcon from "@/assets/images/land/download-white.svg";
import editIcon from "@/assets/images/land/edit.svg";

const APPID = 4002;

export default {
  components: { InstallGuide },
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      logoImg,
      heroImg,
      titleImg,
      highlightsImg,
      genresImg,
      immersiveImg,
      wishImg,
      creatorImg,
      downloadIcon,
      downloadWhiteIcon,
      editIcon,
      menus: [
        { key: "home", label: "首页" },
        { key: "highlights", label: "内容亮点" },
        { key: "genres", label: "剧场类型" },
        { key: "wish", label: "心愿榜" },
        { key: "original", label: "原创内容" },
        { key: "about", label: "关于我们" }
      ],
      activeKey: "home",
      locking: false,
      scrollTimer: null,
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      currUrl: window.location.href,
      cChannel: "",
      onlineServiceLoading: false
    };
  },
  watch: {
    configs(configs) {
      if (!configs) {
        return;
      }
      configs.forEach(item => {
        if (item.configType === "qd_cooperate") {
          this.cChannel = item.link;
        }
      });
    }
  },
  mounted() {
    this.centerNav();
    this.$nextTick(() => {
      this.centerNav();
      requestAnimationFrame(() => this.centerNav());
    });
  },
  beforeDestroy() {
    clearTimeout(this.scrollTimer);
    if (this.scrollRaf) {
      cancelAnimationFrame(this.scrollRaf);
    }
  },
  methods: {
    pageClick(event) {
      landingPageClick(this, {
        tab_key: "main",
        tab_name: "主页",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    },
    onScroll() {
      if (this.locking) {
        return;
      }
      if (this.scrollRaf) {
        return;
      }
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = 0;
        this.syncActive();
      });
    },
    syncActive() {
      const scroller = this.$refs.scroller;
      const header = this.$refs.header;
      if (!scroller || !header) {
        return;
      }
      if (
        scroller.scrollTop + scroller.clientHeight >=
        scroller.scrollHeight - 4
      ) {
        this.setActive("about");
        return;
      }
      const line = header.offsetHeight + 1;
      let current = this.menus[0].key;
      this.menus.forEach(item => {
        const el = this.$refs[item.key];
        if (el && el.offsetTop - scroller.scrollTop <= line) {
          current = item.key;
        }
      });
      this.setActive(current);
    },
    setActive(key) {
      if (this.activeKey === key) {
        return;
      }
      this.activeKey = key;
      this.scrollNavItem(key);
    },
    centerNav() {
      const nav = this.$refs.navScroll;
      if (!nav) {
        return;
      }
      const extra = nav.scrollWidth - nav.clientWidth;
      if (extra > 0) {
        nav.scrollLeft = extra / 2;
      }
    },
    scrollNavItem(key) {
      const nav = this.$refs.navScroll;
      if (!nav) {
        return;
      }
      const el = nav.querySelector('[data-key="' + key + '"]');
      if (!el) {
        return;
      }
      const navRect = nav.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      if (
        elRect.left >= navRect.left + 8 &&
        elRect.right <= navRect.right - 8
      ) {
        return;
      }
      const left = el.offsetLeft - (nav.clientWidth - el.offsetWidth) / 2;
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches;
      nav.scrollTo({
        left: Math.max(0, left),
        behavior: reduce ? "auto" : "smooth"
      });
    },
    scrollToSection(key) {
      if (this.activeKey === key) {
        return;
      }
      const scroller = this.$refs.scroller;
      const section = this.$refs[key];
      const header = this.$refs.header;
      if (!scroller || !section || !header) {
        return;
      }
      this.activeKey = key;
      this.scrollNavItem(key);
      const top = Math.max(0, section.offsetTop - header.offsetHeight);
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches;
      this.locking = true;
      scroller.scrollTo({
        top,
        behavior: reduce ? "auto" : "smooth"
      });
      this.waitScrollEnd();
    },
    waitScrollEnd() {
      const scroller = this.$refs.scroller;
      clearTimeout(this.scrollTimer);
      const done = () => {
        scroller.removeEventListener("scroll", onScroll);
        this.locking = false;
        this.syncActive();
      };
      const onScroll = () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(done, 140);
      };
      scroller.addEventListener("scroll", onScroll);
      this.scrollTimer = setTimeout(done, 800);
    },
    checkIsSafari() {
      const ua = (this.os.userAgent || "").toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    trackDownload(event) {
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    },
    onClient(event) {
      if (this.os && this.os.isPhone) {
        this.onApple(event);
        return;
      }
      this.onAndroid(event);
    },
    onApple(event) {
      if (
        this.os.isPhone &&
        this.switchData &&
        this.switchData.shopIosDownUrl
      ) {
        this.getApkInfo("shopIos", event);
        return;
      }
      if (this.os.isPhone && !this.checkIsSafari()) {
        this.showTip = true;
        this.trackDownload(event);
        return;
      }
      this.getApkInfo("ios", event);
    },
    onAndroid(event) {
      this.getApkInfo("android", event);
    },
    onAndroidSpare(event) {
      this.getApkInfo("androidSpare", event);
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    closeGuide() {
      this.iosPromptShow = false;
      this.androidPromptShow = false;
    },
    async showInstallTutorial(type) {
      if (type === "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(flag, event) {
      let type = "android";
      if (
        flag === "shopIos" ||
        flag === "ios" ||
        flag === "android" ||
        flag === "androidSpare"
      ) {
        type = flag;
      } else if (this.os.isPhone) {
        type = "ios";
      }
      if (type !== "shopIos") {
        await this.showInstallTutorial(type === "ios" ? "ios" : "android");
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      this.trackDownload(event);
    },
    openMobileCompatibleUrl(url) {
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    async openOnlineService(event) {
      const click_coordinates_x = event.clientX;
      const click_coordinates_y = event.clientY;
      const userAgent = this.os.userAgent || "";
      landingPageClick(this, {
        tab_name: "在线客服",
        tab_key: "customer_service",
        click_coordinates_x,
        click_coordinates_y
      });
      if (this.onlineServiceLoading) {
        return;
      }
      this.onlineServiceLoading = true;
      try {
        const res = await getCustomerServiceUrl({
          uid: this.$route.query.uid || getTraceId(),
          appId: APPID,
          deviceType: getDeviceType(userAgent),
          systemType: getSystemType(userAgent),
          systemVersion: getSystemVersion(userAgent)
        });
        const serviceUrl = res && res.data && res.data.data;
        if (serviceUrl) {
          this.openMobileCompatibleUrl(serviceUrl);
          return;
        }
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
      } catch (error) {
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
      } finally {
        this.onlineServiceLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$brand: #ec237f;
$page: #0b0b0d;

.mobilePage {
  height: 100%;
  width: 100%;
  background: $page;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  font-family: "PingFang SC", -apple-system, "Helvetica Neue", Arial, sans-serif;
  color: #f2f2f4;
  button {
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
    appearance: none;
  }
  button:focus {
    outline: none;
  }
}

.stickyHead {
  position: sticky;
  top: 0;
  z-index: 20;
}

.topBar {
  height: 58px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(11, 11, 13, 0.98);
}

.logoWrap {
  display: flex;
  align-items: center;
  gap: 4px;
  .logoImg {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
}

.clientBtn {
  width: 113px;
  height: 36px;
  border: 0;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  transition: transform 150ms ease;
  span {
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    color: #fff;
  }
  &:active {
    transform: scale(0.97);
  }
}

.clientIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 12px;
    height: 12px;
    display: block;
  }
}

.navScroll {
  height: 54px;
  background: rgba(11, 11, 13, 0.8);
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}

.navRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  height: 54px;
  min-width: 100%;
  width: max-content;
  padding: 0 16px;
  box-sizing: border-box;
}

.navItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 54px;
  border: 0;
  background: transparent;
  transition: opacity 120ms ease;
  &:active {
    opacity: 0.7;
  }
}

.navLabel {
  display: grid;
  font-size: 16px;
  line-height: 16px;
}

.navGhost,
.navText {
  grid-area: 1 / 1;
  white-space: nowrap;
}

.navGhost {
  font-weight: 600;
  visibility: hidden;
}

.navText {
  font-weight: 400;
  color: #f2f2f4;
  transition: color 200ms ease;
}

.navItem.is-active .navText {
  font-weight: 600;
  color: $brand;
}

.navLine {
  display: block;
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background: $brand;
  transform: scaleX(0.4);
  opacity: 0;
  transition: transform 220ms ease, opacity 220ms ease;
}

.navItem.is-active .navLine {
  transform: scaleX(1);
  opacity: 1;
}

.hero {
  position: relative;
  height: 560px;
  background: #000;
  overflow: hidden;
}

.heroVisual {
  position: absolute;
  left: 0;
  top: 0;
  width: 375px;
  height: 470px;
  overflow: hidden;
}

.heroPhoto {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.heroShade {
  position: absolute;
  left: 0;
  top: 200px;
  width: 375px;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(11, 11, 13, 0) 0%,
    rgba(11, 11, 13, 0.85) 55%,
    #0b0b0d 100%
  );
}

.heroCopy {
  position: absolute;
  left: 0;
  right: 0;
  top: 237px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.heroTitle {
  width: 295px;
  height: 122px;
  display: block;
  object-fit: contain;
}

.heroSlogan,
.heroDesc {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;
}

.heroSlogan {
  line-height: 20px;
}

.heroTag {
  padding: 2px 10px;
  border-radius: 99px;
  border: 1px solid $brand;
  background: rgba(236, 35, 127, 0.1);
  color: $brand;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

.downloadRow {
  position: absolute;
  left: 0;
  top: 486px;
  width: 375px;
  height: 46px;
  padding: 0 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.dlBtn {
  width: 110px;
  height: 44px;
  border: 0;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  transition: transform 150ms ease;
  &:active {
    transform: scale(0.97);
  }
}

.dlIcon {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
}

.dlText {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.dlMain {
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  color: #fff;
  white-space: nowrap;
}

.dlSub {
  font-size: 10px;
  line-height: 12px;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
}

.highlights,
.genres,
.immersive {
  position: relative;
  overflow: hidden;
  background: #0b0b0d;
}

.highlights {
  height: 277px;
}

.genres {
  height: 777px;
}

.immersive {
  height: 722px;
}

.sectionFill {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.wish {
  height: 426px;
  box-sizing: border-box;
  padding: 0 0 21px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: linear-gradient(180deg, #0b0b0d 0%, #1a0711 50%, #0b0b0d 100%);
}

.wishArt {
  width: 375px;
  height: 336px;
  display: block;
  object-fit: cover;
  flex-shrink: 0;
}

.wishBtn {
  width: 280px;
  height: 48px;
  border: 0;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  transition: transform 150ms ease;
  span {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #fff;
  }
  &:active {
    transform: scale(0.97);
  }
}

.wishIcon {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    height: 16px;
    display: block;
  }
}

.creator {
  position: relative;
  height: 259px;
  overflow: hidden;
  background: #0b0b0d;
}

.creatorBg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}

.creatorCopy {
  position: absolute;
  left: 12px;
  top: 59px;
  width: 215px;
  height: 125px;
  object-fit: contain;
}

.about {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 36px 0;
  background: linear-gradient(90deg, #0b0b0d 0%, #1d0812 50%, #0b0b0d 100%);
}

.aboutLogo {
  display: flex;
  align-items: center;
  gap: 7px;
  img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 25px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.25px;
  }
}

.aboutSlogan {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 2px;
  white-space: nowrap;
}

.footer {
  position: relative;
  padding: 23px 16px 21px;
  box-sizing: border-box;
  background: #141417;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.footerLogo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: -0.13px;
    white-space: nowrap;
  }
}

.footerSlogan {
  margin: 12px 0 0;
  text-align: center;
  color: #6b6b74;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
}

.footerAddresses {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 21px;
  color: #6b6b74;
  font-size: 12px;
  line-height: 18px;
  p {
    display: flex;
    flex-wrap: wrap;
    column-gap: 4px;
    margin: 0;
  }
  span {
    white-space: nowrap;
  }
  a {
    max-width: 100%;
    color: $brand;
    text-decoration: none;
    overflow-wrap: anywhere;
  }
}

.footerCols {
  margin-top: 21px;
  display: flex;
  justify-content: center;
  gap: 72px;
}

.footerCol {
  display: flex;
  flex-direction: column;
  gap: 9px;
  font-size: 12px;
  line-height: 17px;
  color: #6b6b74;
  white-space: nowrap;
  p {
    margin: 0;
  }
}

.footerTitle {
  color: #f2f2f4;
  font-weight: 600;
}

.copyright {
  margin: 55px 0 0;
  text-align: center;
  color: #6b6b74;
  font-size: 11px;
  line-height: 15px;
  white-space: nowrap;
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;
  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }
  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }
  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }
  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #ec237f;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
